import { useParams } from 'react-router-dom';

import { CheckoutSessionContextProvider } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { CheckoutSessionDetail } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/CheckoutSessionDetail';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const CheckoutSessionDetailModule = withPermissionsModule(() => {
  const { checkoutSessionId } = useParams();

  if (!checkoutSessionId) return null;

  return (
    <CheckoutSessionContextProvider>
      <CheckoutSessionDetail checkoutSessionId={checkoutSessionId} />
    </CheckoutSessionContextProvider>
  );
});
